<template>
	<v-card class="filter-panel" elevation="0" outlined>
		<v-card-title class="filter-panel__header">
			<div class="filter-panel__title">
				<v-icon color="primary" class="mr-2">mdi-filter-variant</v-icon>
				Filters
			</div>
			<v-btn
				icon
				small
				color="grey darken-1"
				@click="resetFilter">
				<v-icon small>mdi-close</v-icon>
			</v-btn>
		</v-card-title>
		<v-card-text class="filter-panel__body">
			<v-text-field
				rounded
				outlined
				dense
				hide-details
				label="Title"
				class="mb-3"
				prepend-inner-icon="mdi-magnify"
				v-model="filter.searchText"></v-text-field>

			<div class="filter-panel__section-title">Price</div>
			<div class="filter-panel__range">
				<v-text-field
					rounded
					outlined
					dense
					hide-details
					label="Min"
					v-model.number="filter.minPrice"
					@change="
						filter.minPrice =
							filter.minPrice != '' ? filter.minPrice : null
					"
					prefix="$"></v-text-field>
				<v-text-field
					rounded
					outlined
					dense
					hide-details
					label="Max"
					v-model.number="filter.maxPrice"
					@change="
						filter.maxPrice =
							filter.maxPrice != '' ? filter.maxPrice : null
					"
					prefix="$"></v-text-field>
			</div>

			<div class="filter-panel__section-title">US Quantity</div>
			<div class="filter-panel__range">
				<v-text-field
					rounded
					outlined
					dense
					hide-details
					label="Min"
					@change="
						filter.minUsQuantity =
							filter.minUsQuantity != ''
								? filter.minUsQuantity
								: null
					"
					v-model.number="filter.minUsQuantity"></v-text-field>
				<v-text-field
					rounded
					outlined
					dense
					hide-details
					label="Max"
					@change="
						filter.maxUsQuantity =
							filter.maxUsQuantity != ''
								? filter.maxUsQuantity
								: null
					"
					v-model.number="filter.maxUsQuantity"></v-text-field>
			</div>

			<div class="filter-panel__section-title">VN Quantity</div>
			<div class="filter-panel__range">
				<v-text-field
					rounded
					outlined
					dense
					hide-details
					label="Min"
					@change="
						filter.minVnQuantity =
							filter.minVnQuantity != ''
								? filter.minVnQuantity
								: null
					"
					v-model.number="filter.minVnQuantity"></v-text-field>
				<v-text-field
					rounded
					outlined
					dense
					hide-details
					label="Max"
					@change="
						filter.maxVnQuantity =
							filter.maxVnQuantity != ''
								? filter.maxVnQuantity
								: null
					"
					v-model.number="filter.maxVnQuantity"></v-text-field>
			</div>

			<div class="filter-panel__section-title">Total Quantity</div>
			<div class="filter-panel__range">
				<v-text-field
					rounded
					outlined
					dense
					hide-details
					label="Min"
					@change="
						filter.minQuantity =
							filter.minQuantity != '' ? filter.minQuantity : null
					"
					v-model.number="filter.minQuantity"></v-text-field>
				<v-text-field
					rounded
					outlined
					dense
					hide-details
					label="Max"
					@change="
						filter.maxQuantity =
							filter.maxQuantity != '' ? filter.maxQuantity : null
					"
					v-model.number="filter.maxQuantity"></v-text-field>
			</div>

			<v-autocomplete
				rounded
				outlined
				dense
				hide-details
				label="Brand"
				clearable
				class="mb-3"
				:items="brands"
				item-text="displayName"
				item-value="id"
				v-model="filter.brandId"></v-autocomplete>
			<v-autocomplete
				rounded
				outlined
				dense
				hide-details
				label="Category"
				clearable
				class="mb-3"
				:items="categories"
				item-text="displayName"
				item-value="id"
				v-model="filter.lvl1Id"></v-autocomplete>
			<v-autocomplete
				rounded
				outlined
				dense
				hide-details
				label="Type"
				clearable
				class="mb-3"
				:items="productTypes"
				item-text="displayName"
				item-value="id"
				v-model="filter.lvl2Id"></v-autocomplete>

			<div class="filter-panel__actions">
				<v-btn
					color="primary"
					depressed
					icon
					@click="generateProductReport"
					:loading="isExportLoading">
					<v-icon>mdi-download</v-icon>
				</v-btn>
				<v-btn
					color="primary"
					depressed
					rounded
					class="flex-grow-1"
					@click="emitEvent"
					:loading="isLoading">
					<v-icon left small>mdi-sync</v-icon>
					Apply
				</v-btn>
			</div>
		</v-card-text>
	</v-card>
</template>
<script>
import generalMixin from "@/js/general-mixin";
import backendService from "@/services/backend-service";
export default {
    name: "FilterPanel",
    mixins: [generalMixin],
    mounted: function () {
        let query = this.$route.query;
        let filter = {};
        if (query.searchText) filter.searchText = query.searchText;
        if (query.minPrice) filter.minPrice = Number(query.minPrice);
        if (query.maxPrice) filter.maxPrice = Number(query.maxPrice);
        if (query.minQuantity) filter.minQuantity = Number(query.minQuantity);
        if (query.maxQuantity) filter.maxQuantity = Number(query.maxQuantity);
        if (query.minVnQuantity) filter.minVnQuantity = Number(query.minVnQuantity);
        if (query.maxVnQuantity) filter.maxVnQuantity = Number(query.maxVnQuantity);
        if (query.minUsQuantity) filter.minUsQuantity = Number(query.minUsQuantity);
        if (query.maxUsQuantity) filter.maxUsQuantity = Number(query.maxUsQuantity);
        if (query.brandId) filter.brandId = Number(query.brandId);
        if (query.lvl1Id) filter.lvl1Id = Number(query.lvl1Id);
        if (query.lvl2Id) filter.lvl2Id = Number(query.lvl2Id);
        this.filter = filter;
    },
    data() {
        return { isExportLoading: false, isLoading: false, filter: {} };
    },
    computed: {
        brands() {
            if (
                this.$store.getters["dropdownToOptions"] &&
                this.$store.getters["dropdownToOptions"]["brand"]
            ) {
                return this.$store.getters["dropdownToOptions"]["brand"]
                    .options;
            }
            return [];
        },
        categories() {
            if (
                this.$store.getters["dropdownToOptions"] &&
                this.$store.getters["dropdownToOptions"]["category"]
            ) {
                return this.$store.getters["dropdownToOptions"]["category"]
                    .options;
            }
            return [];
        },
        productTypes() {
            if (
                this.$store.getters["dropdownToOptions"] &&
                this.$store.getters["dropdownToOptions"]["productType"]
            ) {
                return this.$store.getters["dropdownToOptions"]["productType"]
                    .options;
            }
            return [];
        },
    },
    methods: {
        emitEvent() {
            this.isLoading = true;
            let newQuery = { ...this.filter };
            this.$router.replace({ query: newQuery }).catch(() => {});
            this.timer(1000).then(() => {
                this.isLoading = false;
            });
        },
        generateProductReport() {
            this.isExportLoading = true;
            backendService
                .generateProductReport(this.filter)
                .then((response) => {
                    this.timer(1000).then(() => {
                        this.isExportLoading = false;
                    });
                    var binary = atob(response.data);

                    var array = new Uint8Array(binary.length);
                    for (var i = 0; i < binary.length; i++) {
                        array[i] = binary.charCodeAt(i);
                    }

                    const url = window.URL.createObjectURL(new Blob([array]));

                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "Products.xlsx";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                });
        },
        resetFilter() {
            this.filter = {};
            this.$router.replace({ query: {} }).catch(() => {});
        },
    },
};
</script>
<style scoped>
.filter-panel {
	background: #ffffff;
	border-color: #dfe3e8;
	border-radius: 8px;
	overflow: hidden;
}
.filter-panel__header {
	align-items: center;
	background: #f8fafc;
	border-bottom: 1px solid #e5e7eb;
	display: flex;
	justify-content: space-between;
	min-height: 52px;
	padding: 10px 12px;
}
.filter-panel__title {
	align-items: center;
	color: #263238;
	display: flex;
	font-size: 1rem;
	font-weight: 600;
}
.filter-panel__body {
	padding: 12px;
}
.filter-panel__section-title {
	color: #607d8b;
	font-size: 0.75rem;
	font-weight: 700;
	letter-spacing: 0;
	margin-bottom: 4px;
	text-transform: uppercase;
}
.filter-panel__range {
	display: flex;
	gap: 8px;
	margin-bottom: 14px;
}
.filter-panel__actions {
	align-items: center;
	display: flex;
	gap: 8px;
	padding-top: 2px;
}
</style>
